import { apiService } from '../services/apiService';
import type { InterestSource } from '../config/booking';

/**
 * Record that someone pressed a booking CTA, so a lead is captured even when
 * they never book anything.
 *
 * Deliberately fire-and-forget, and deliberately not awaited by callers: the
 * calendar has to open on the same user gesture or the popup blocker eats it,
 * and a logging failure must never cost us the actual booking.
 */
export function recordInterest(
  source: InterestSource,
  context: Record<string, any> = {},
): void {
  try {
    void apiService
      .recordInterestClick(source, context)
      .catch(() => { /* logging is best-effort by design */ });
  } catch {
    /* never let instrumentation break a CTA */
  }
}
